module.exports = __webpack_public_path__ + "static/media/Cairo-Bold.8c78be6d.ttf";